import React from 'react';

import { ListItem } from '@mui/material';
import { CheckboxCDS } from 'app/shared/componentsRestyled/coreDesignSystem/form';
import PropTypes from 'prop-types';

import { DocumentTestIds } from '../../document.testIds';
import { aiExtractionResultOptions } from '../DocumentView.constants';

const AiLayersPopover = ({ onSelectAiLayer, checkedAiLayers }) => {
  return (
    <div>
      {aiExtractionResultOptions.map(({ name, value }) => (
        <ListItem button dense className="flex items-center" key={value}>
          <CheckboxCDS
            fullWidth
            data-ai-layer-value={value}
            dataTestId={DocumentTestIds.getAiLayerCheckboxId(value)}
            label={name}
            name={value}
            value={checkedAiLayers[value]?.isChecked}
            onClick={onSelectAiLayer}
          />
        </ListItem>
      ))}
    </div>
  );
};

AiLayersPopover.propTypes = {
  checkedAiLayers: PropTypes.object,
  onSelectAiLayer: PropTypes.func,
};

export default AiLayersPopover;
